import { useSelector } from 'react-redux';
import { getLiteTradePingError, getLiteTradeSocketState } from '../../modules/LiteTrade/liteTradeSelectors';
import { NoConnection } from '../../presentationalComponents/NoConnection/NoConnection';
import { useLangContext } from '../../providers/LangProvider/LangProviderContext';
import { useCallback } from 'react';
import { RouterPaths } from '../../app/appConstants';
import appHistory from '../../app/appHistory';
import { getOnlineStatus } from '../../modules/InternetConnection/internetConnectionSelectors';

interface IMobileAppPrivateRouteProps {
    withWS?: boolean;
}

function MobileAppPrivateRouteConnectionError({ withWS }: IMobileAppPrivateRouteProps) {
    const liteTradeSocketState = useSelector(getLiteTradeSocketState);
    const liteTradePingError = useSelector(getLiteTradePingError);
    const isOnline = useSelector(getOnlineStatus);
    const { getLangPath } = useLangContext();
    const lang = useCallback(
        (key: string) => {
            const result = getLangPath(key);
            if (result === key) {
                return undefined;
            }
            return result;
        },
        [getLangPath],
    );
    const onClick = useCallback(() => {
        appHistory.push(`${RouterPaths.support}`);
    }, []);

    if (withWS && !!liteTradePingError && liteTradeSocketState !== 1 && isOnline) {
        return (
            <NoConnection
                onClick={onClick}
                title={lang('error.connection.dx.title')}
                description={lang('error.connection.dx.description')}
                btnText={lang('error.connection.dx.action')}
            />
        );
    }
    return null;
}

export default MobileAppPrivateRouteConnectionError;
